import { render, staticRenderFns } from "./invoice-success.vue?vue&type=template&id=f629122a&scoped=true&"
import script from "./invoice-success.vue?vue&type=script&lang=js&"
export * from "./invoice-success.vue?vue&type=script&lang=js&"
import style0 from "./invoice-success.vue?vue&type=style&index=0&id=f629122a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f629122a",
  null
  
)

export default component.exports